import React from "react";
import Footer from "./Footer";
import NewNavbar from "./NewNavbar";
import { ChevronDown } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";

export default function Home() {
  const [openIndex, setOpenIndex] = useState(null);
  const topRef = useRef(null);
  const demoRef = useRef(null);

  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    axios
      .get("https://api.livestockify.com/api/admin/testimonials")
      .then((res) => {
        setTestimonials(res.data);
      })
      .catch((err) => console.error(err));
  }, []);

  const logos = [
    "http://res.cloudinary.com/dt8emxboh/image/upload/v1773989950/ebqe6t6mb8t67l3zbtwn.png",
    "http://res.cloudinary.com/dt8emxboh/image/upload/v1773990849/d7bhufrbhgp1vkppkyb3.png",
    "http://res.cloudinary.com/dt8emxboh/image/upload/v1773990891/sxxmapnqnvh1zo7wqqdh.png",
    "http://res.cloudinary.com/dt8emxboh/image/upload/v1773990931/yxrfdyqabtd9eeabqwj6.png",
  ];

  const sectionRef = useRef(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimate(true);
        }
      },
      { threshold: 0.3 },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  //Book a Demo call api

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Phone validation
    if (!/^\d{10}$/.test(formData.phone)) {
      toast.error("Phone number must be exactly 10 digits");
      return;
    }

    try {
      await axios.post("https://api.livestockify.com/api/admin/queries", {
        name: formData.firstName + " " + formData.lastName,
        phone: formData.phone,
        email: formData.email,
        message: formData.message,
      });

      toast.success("Message sent successfully ✅");

      // reset form
      setFormData({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong ❌");
    }
  };

  // Solutions part api

  const [cards, setCards] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "https://api.livestockify.com/api/admin/behind-idea",
        );
        setCards(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="w-full">
      <Toaster position="top-right" reverseOrder={false} />
      <NewNavbar />
      {/* ================= HERO SECTION ================= */}

      <section ref={topRef} className="bg-white py-12 md:py-20 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-6 lg:px-0 grid md:grid-cols-2 gap-10 items-center">
          {/* LEFT CONTENT */}
          <div className=" w-full text-center md:text-left mx-auto md:mx-0 pl-0 md:pl-6 lg:pl-0">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight">
              <span className="text-[#6FAF1E]">Connect.Monitor.</span>{" "}
              <span className=""></span>
              <br />
              <span className="text-[#6FAF1E]">
                Optimise with <span className="text-[#0F6D73]">AI</span>
              </span>
            </h1>

            <p className="mt-4 text-gray-600 text-lg md:text-base max-w-md">
              KuppiSmart integrates IoT hardware and AI analytics to track
              parameters, detect risks, and improve performance across
              industries.
            </p>
          </div>

          {/* RIGHT IMAGE */}

          <div className="flex justify-center md:justify-end items-end relative gap-6 md:gap-10">
            {/* GREEN GLOW */}
            <div className="absolute w-64 h-64 md:w-80 md:h-80 bg-[#6FAF1E]/40 blur-3xl rounded-full right-10 top-10 z-0"></div>

            <img
              src="http://res.cloudinary.com/dt8emxboh/image/upload/v1772726771/cme0iywzd3dabez302cv.png"
              alt="Device"
              className="w-40 md:w-60 lg:w-72 relative "
            />

            <img
              src="http://res.cloudinary.com/dt8emxboh/image/upload/v1772726888/ahj0tsfyafvyu027e0ih.png"
              alt="Mobile"
              className="w-44 sm:w-52 md:w-64 lg:w-72 xl:w-[300px] relative z-10"
            />
          </div>
        </div>

        {/* LOGO MARQUEE */}

        <div className="mt-12 border-gray-300 pt-6 overflow-hidden w-full">
          <p className="text-[#0F6D73] text-start text-lg font-semibold mb-4 px-6 max-w-7xl mx-auto">
            Chosen by forward-thinking companies
          </p>
          <div className="relative w-full overflow-hidden">
            <div className="flex flex-wrap justify-center items-center gap-6 sm:gap-10 md:gap-14 lg:gap-52 w-full px-4">
              {[...logos].map((logo, index) => (
                <img
                  key={index}
                  src={logo}
                  alt="company"
                  className="h-8 sm:h-10 md:h-12 lg:h-14 object-contain"
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ================= PROCESS SECTION ================= */}

      <section ref={sectionRef} className="py-10 bg-[#F8FAF6] text-center">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-bold">
            From <span className="text-green-600">Field</span> sensors to{" "}
            <span className="text-teal-600">Intelligent</span> Decisions.
          </h2>

          <p className="mt-4 text-[#4A4F4D] font-semibold text-lg max-w-4xl mx-auto">
            Our IoT devices continuously capture critical farm and
            infrastructure data, analysed in the AI cloud to deliver real-time
            insights, alerts , and easy-to-understand visualizations on your
            mobile.
          </p>

          {/* FLOW */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-5 items-center gap-10">
            {/* Device */}
            <div className="flex flex-col items-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1772726771/cme0iywzd3dabez302cv.png"
                alt="Device"
                className="w-48 md:w-68"
              />
              <p className="mt-6 font-semibold text-lg">IoT Device</p>
            </div>

            {/* WIFI SIGNAL */}

            <div
              className={`flex items-center justify-center ${
                animate ? "wifi-animate" : ""
              }`}
            >
              <svg width="120" height="60" viewBox="0 0 120 60">
                {/* DOT 1 */}
                <circle
                  cx="10"
                  cy="30"
                  r="6"
                  fill="black"
                  className="step step1"
                />

                {/* ARC 1 ( ) shape */}
                <path
                  d="M40 10 Q55 30 40 50"
                  stroke="black"
                  strokeWidth="6"
                  fill="none"
                  strokeLinecap="round"
                  className="step step2"
                />

                {/* DOT 2 */}
                <circle
                  cx="70"
                  cy="30"
                  r="6"
                  fill="black"
                  className="step step3"
                />

                {/* ARC 2 (inner ) */}
                <path
                  d="M90 12 Q105 30 90 48"
                  stroke="black"
                  strokeWidth="6"
                  fill="none"
                  strokeLinecap="round"
                  className="step step4"
                />

                {/* ARC 3 (outer ) */}
                <path
                  d="M105 5 Q125 30 105 55"
                  stroke="black"
                  strokeWidth="6"
                  fill="none"
                  strokeLinecap="round"
                  className="step step5"
                />
              </svg>
            </div>

            {/* Cloud */}
            <div className="flex flex-col items-center">
              <div className="relative flex items-end justify-center -mt-16 h-[350px] md:h-[420px]">
                {/* Main Image */}

                {/* Left Cloud */}
                <img
                  src="http://res.cloudinary.com/dt8emxboh/image/upload/v1774960586/dgc2qfufsl7imwolzjxe.png"
                  alt="cloud"
                  className="animate-cloudLeft w-[100px] absolute -left-[85px] bottom-40 "
                />

                <img
                  src="http://res.cloudinary.com/dt8emxboh/image/upload/v1774006416/ojsbzafdoi3kgj8kwvxo.png"
                  className=" md:w-18  relative z-10 bottom-[35%] translate-y-[25%] "
                  alt="AI Cloud"
                />

                {/* Right Cloud */}
                <img
                  src="http://res.cloudinary.com/dt8emxboh/image/upload/v1774961152/lirnxvutnqp5u3csbgnd.png"
                  alt="cloud"
                  className="animate-cloudRight absolute -right-[85px] bottom-40 "
                />
              </div>
              <p className="-mt-16 font-semibold text-lg">AI/ML Cloud</p>
            </div>

            {/* WIFI SIGNAL */}

            <div
              className={`flex items-center justify-center ${
                animate ? "wifi-animate" : ""
              }`}
            >
              <svg width="120" height="60" viewBox="0 0 120 60">
                {/* DOT 1 */}
                <circle
                  cx="10"
                  cy="30"
                  r="6"
                  fill="black"
                  className="step step1"
                />

                {/* ARC 1 ( ) shape */}
                <path
                  d="M40 10 Q55 30 40 50"
                  stroke="black"
                  strokeWidth="6"
                  fill="none"
                  strokeLinecap="round"
                  className="step step2"
                />

                {/* DOT 2 */}
                <circle
                  cx="70"
                  cy="30"
                  r="6"
                  fill="black"
                  className="step step3"
                />

                {/* ARC 2 (inner ) */}
                <path
                  d="M90 12 Q105 30 90 48"
                  stroke="black"
                  strokeWidth="6"
                  fill="none"
                  strokeLinecap="round"
                  className="step step4"
                />

                {/* ARC 3 (outer ) */}
                <path
                  d="M105 5 Q125 30 105 55"
                  stroke="black"
                  strokeWidth="6"
                  fill="none"
                  strokeLinecap="round"
                  className="step step5"
                />
              </svg>
            </div>

            {/* Notifications */}
            <div className="flex flex-col items-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1772728696/tbg9e4krq4euzziqnizn.png"
                alt="Notifications"
                className="w-40 md:w-40"
              />
              <p className="mt-6 font-semibold text-lg">
                Real Time <br /> Notifications
              </p>
            </div>
          </div>
        </div>

        {/* CSS */}
        <style jsx>
          {`
            .step {
              opacity: 0;
            }

            .step1 {
              animation: stepAnim 3s infinite;
            }

            .step2 {
              animation: stepAnim 3s infinite;
              animation-delay: 0.4s;
            }

            .step3 {
              animation: stepAnim 3s infinite;
              animation-delay: 0.8s;
            }

            .step4 {
              animation: stepAnim 3s infinite;
              animation-delay: 1.2s;
            }

            .step5 {
              animation: stepAnim 3s infinite;
              animation-delay: 1.6s;
            }

            @keyframes stepAnim {
              0% {
                opacity: 0;
              }
              20% {
                opacity: 1;
              }
              40% {
                opacity: 1;
              }
              60% {
                opacity: 0;
              }
              100% {
                opacity: 0;
              }
            }
          `}
        </style>

        <style>
          {`
          @keyframes cloudLeftMove {
            0% { transform: translateX(0); }
            50% { transform: translateX(12px); }
            100% { transform: translateX(0); }
          }

          @keyframes cloudRightMove {
            0% { transform: translateX(0); }
            50% { transform: translateX(-12px); }
            100% { transform: translateX(0); }
          }

          .animate-cloudLeft {
            animation: cloudLeftMove 4s ease-in-out infinite;
          }

          .animate-cloudRight {
            animation: cloudRightMove 4s ease-in-out infinite;
          }
        `}
        </style>
      </section>

      {/* ================= RELIABLE CHOICE SECTION ================= */}
      <section className="bg-[#F8FAF6] py-20">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold">
            The Reliable Choice for Smart{" "}
            <span className="text-[#6FAF1E]">Monitoring</span>
          </h2>

          <p className="text-gray-600 mt-4 max-w-3xl mx-auto">
            Kuppismart IoT devices are built to perform in harsh environments,
            capturing critical parameters with high accuracy and seamlessly
            connecting to the AI cloud for uninterrupted monitoring and
            real-time notifications.
          </p>

          {/* Feature Grid */}
          <div className="grid md:grid-cols-3 gap-10 mt-20 items-center">
            {/* Left Features */}
            <div className="space-y-10 md:space-y-40 text-left order-2 md:order-none">
              <div className="flex gap-4">
                <img
                  src="http://res.cloudinary.com/dt8emxboh/image/upload/v1772980634/hffpilcaerz7d3syeehp.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <h4 className="font-semibold text-lg text-teal-700">
                    Multi-Parameter Precision Sensing
                  </h4>
                  <p className="text-black text-xl">
                    Accurately measures critical environmental and operational
                    parameters across aquaculture, poultry, gas, and water
                    systems.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <img
                  src="http://res.cloudinary.com/dt8emxboh/image/upload/v1772980868/krpeihfve3chewte8czm.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <h4 className="font-semibold text-lg text-teal-700">
                    Flexible Power Options
                  </h4>
                  <p className="text-black text-xl">
                    Operates reliably with mains power, battery, or solar energy
                    ensuring continuous monitoring even in remote areas.
                  </p>
                </div>
              </div>
            </div>

            {/* Center Device */}
            <div className="flex justify-center relative order-1 md:order-none">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773217622/lumpkmp8rs7bdomab49m.png"
                alt="background-device"
                className="absolute top-6 -translate-y-1/2 w-64 md:w-80 z-0"
              />

              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1772726771/cme0iywzd3dabez302cv.png"
                alt="device"
                className="w-56 md:w-72 relative z-10 drop-shadow-xl"
              />
            </div>

            {/* Right Features */}
            <div className="space-y-10 md:space-y-40 text-left order-2 md:order-none">
              <div className="flex gap-4">
                <img
                  src="http://res.cloudinary.com/dt8emxboh/image/upload/v1772980740/huoyn8fiyrtee4kpvbl6.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <h4 className="font-semibold text-lg text-teal-700">
                    True 24/7 Continuous Operation
                  </h4>
                  <p className="text-black text-xl">
                    Designed for uninterrupted, round-the-clock sensing and data
                    transmission so critical conditions are tracked without
                    gaps.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <img
                  src="http://res.cloudinary.com/dt8emxboh/image/upload/v1772980994/euatawz1m22rfylw2tsd.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <h4 className="font-semibold text-lg text-teal-700">
                    Wi-Fi & Cellular Connectivity
                  </h4>
                  <p className="text-black text-xl">
                    Seamlessly connects via Wi-Fi or cellular networks to
                    securely transmit data to the Kuppismart cloud.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= SOLUTIONS SECTION ================= */}
      <section className="py-15 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-bold text-center">
            Innovative <span className="text-[#6FAF1E]">Solutions</span> We
            Offer
          </h2>

          <p className="text-gray-600 mt-4 text-center max-w-3xl mx-auto">
            From industrial gas safety to sustainable farming, Kuppismart
            combines IoT monitoring and AI intelligence to optimize
            environments, detect risks early, and enhance performance.
          </p>

          {/* Cards */}
          <div className="grid md:grid-cols-2 gap-6 mt-14">
            {cards.map((item) => (
              <div
                key={item.id}
                className="relative rounded-xl overflow-hidden"
              >
                {/* Image */}
                <img
                  src={item.imageUrl}
                  alt={item.name}
                  className="w-full h-[250px] md:h-[300px] object-cover"
                />

                {/* Overlay Description */}
                <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/70 to-transparent p-4">
                  <p className="text-white font-bold text-lg">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= FAQ SECTION ================= */}

      <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-bold text-center">
            Got <span className="text-[#0F6D73]">Questions?</span> We've Got{" "}
            <span className="text-[#6FAF1E]">Answers</span>
          </h2>

          <p className="text-center text-gray-600 mt-3">
            Everything you need to know about our IoT solutions, features,
            setup, and ongoing support.
          </p>

          <div className="mt-12 space-y-4 max-w-2xl mx-auto">
            {[
              {
                q: "What does Kuppismart provide?",
                a: "Kuppismart delivers IoT-based monitoring and automation solutions for aquaculture, poultry and environmental management. Our systems collect real-time data, provide AI insights, and help farmers and industries optimize operations and productivity.",
              },
              {
                q: "What parameters can your IoT devices monitor?",
                a: "Our devices monitor critical parameters such as temperature, humidity, water quality (pH, DO, TDS, ammonia), gas levels, and environmental conditions.",
              },
              {
                q: "How can I view my farm or facility data?",
                a: "All sensor data is available in real time through our mobile and web dashboards where users can view trends, alerts and analytics.",
              },
              {
                q: "Do you provide installation and setup support?",
                a: "Yes, our team handles device installation, calibration, and system setup at your site.",
              },
              {
                q: "What kind of alerts does the system provide?",
                a: "The system sends instant alerts when parameters go beyond safe limits through mobile app notifications, SMS, or dashboard alerts.",
              },
              {
                q: "Is internet required for the system to work?",
                a: "Yes, an internet connection is required for real-time monitoring and remote dashboard access.",
              },
              {
                q: "Can your solutions integrate with existing farm equipment?",
                a: "Yes, our solutions can integrate with existing farm equipment depending on the deployment.",
              },
              {
                q: "Do you offer AI insights or analytics?",
                a: "Yes. Our platform analyzes collected data to provide AI-based insights and recommendations.",
              },
              {
                q: "What maintenance is required for the devices?",
                a: "Devices require minimal maintenance such as periodic sensor cleaning and calibration.",
              },
              {
                q: "How do I purchase or request a demo?",
                a: "You can contact us through our website contact form, phone, or email to request pricing or a live demo.",
              },
            ].map((item, index) => (
              <div
                key={index}
                className={`rounded-md transition-all duration-200 
    ${openIndex === index ? "bg-[#C9D8B5]" : "bg-transparent"}
    hover:bg-[#C9D8B5] active:bg-[#C9D8B5]`}
              >
                {/* Question */}
                <div
                  onClick={() =>
                    setOpenIndex(openIndex === index ? null : index)
                  }
                  className="flex items-center p-3 cursor-pointer"
                >
                  <ChevronDown
                    size={24}
                    className={`transition-transform duration-300 ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  />

                  <p className="ml-4 md:ml-6 text-base md:text-lg font-medium text-gray-900">
                    {item.q}
                  </p>
                </div>

                {/* Answer */}
                {openIndex === index && (
                  <p className="px-10 md:px-12 pb-4 text-gray-700 text-sm md:text-base leading-relaxed">
                    {item.a}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= TESTIMONIAL SECTION ================= */}
      <section className="py-15 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-bold text-center">
            Trusted Experiences from{" "}
            <span className="text-[#6FAF1E]">Our Clients</span> Across
            Industries
          </h2>

          <p className="text-center text-gray-600 mt-3 max-w-3xl mx-auto">
            Discover how our IoT and AI technologies are helping customers
            improve productivity, reduce risks, and make smarter decisions.
          </p>

          <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-6 mt-14">
            {testimonials?.length > 0 &&
              testimonials?.map((item, index) => (
                <div
                  key={item.id || index}
                  className="bg-white border rounded-xl p-6 shadow-sm relative max-w-sm w-full mx-auto flex flex-col justify-between min-h-[260px] md:min-h-[300px]"
                >
                  <img
                    src="http://res.cloudinary.com/dt8emxboh/image/upload/v1774520774/evj4ywya0epsx2fqaucu.png"
                    alt="quote"
                    className="absolute -top-0 left-3 w-7 h-7 p-2 rounded-full shadow"
                  />

                  <p className="text-black text-left pb-10 border-b border-gray-300">
                    {item.testimonial}
                  </p>

                  <div className="flex items-center gap-3 mt-6 ">
                    <img
                      src={item.imageUrl}
                      alt="client"
                      className="w-10 h-10 rounded-full"
                    />

                    <div>
                      <h4 className="font-semibold text-left">{item.name}</h4>

                      <p className="text-xs text-gray-500">{item.position}</p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>

      {/* ================= BOOK DEMO SECTION ================= */}
      <section ref={demoRef} className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-center md:text-left">
            <h2 className="text-4xl md:text-5xl font-bold">
              Book a <span className="text-[#6FAF1E]">Demo</span> Today
            </h2>

            <p className="text-gray-600 mt-6 text-lg max-w-md mx-auto md:mx-0">
              Book a Demo today to discover how Kuppismart can optimise your
              farm with IoT and AI technologies.
            </p>
          </div>

          {/* Form Card */}
          <div className="bg-white p-8 rounded-xl shadow-md">
            <form onSubmit={handleSubmit} className="space-y-5">
              {/* Name Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-start font-medium mb-1">
                    First Name
                  </label>

                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="Enter Your First Name"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>

                <div>
                  <label className="block text-start font-medium mb-1">
                    Last Name
                  </label>

                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Enter Your Last Name"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
              </div>

              {/* Contact Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-start font-medium mb-1">
                    Phone Number
                  </label>

                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter Your Phone Number"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>

                <div>
                  <label className="block text-start font-medium mb-1">
                    Email-ID
                  </label>

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter Your Email-ID"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
              </div>

              {/* Message */}
              <div>
                <label className="block text-start font-medium mb-1">
                  How can we help you?
                </label>

                <textarea
                  rows="4"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Enter Your Message"
                  required
                  className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* Button */}
              <button
                type="submit"
                className="w-full bg-[#56BF5D] text-white py-3 rounded-md font-medium hover:bg-green-700 transition"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
